import { refinementList } from "instantsearch.js/es/widgets";
import { customizedCheckbox } from "./search_html_helpers";

const countriesRefinementWidget = () =>
  refinementList({
    container: "#countries-refinement",
    attribute: "country.name",
    operator: "and",
    cssClasses: { list: "list-unstyled" },
    templates: { item: customizedCheckbox },
  });

export default countriesRefinementWidget;
